import { reactive } from "histoire/dist/node/vendors/vue.js"
        export const markdownFiles = reactive({})
        if (import.meta.hot) {
          if (!window.__hst_md_hmr) {
            window.__hst_md_hmr = (newModule) => {
              markdownFiles[newModule.relativePath] = () => newModule
            }
          }

          import.meta.hot.accept(newModule => {
            Object.assign(markdownFiles, newModule.markdownFiles)
          })
        }